module.exports = __webpack_public_path__ + "img/dxzg.c4a3cec5.png";